import { Box, Stack, styled, Typography } from '@mui/material'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormSelectField } from 'src/components/FormCore'
import { ICustomerFormSchema } from 'src/generated-types/form-schema'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { ChecklistAssignmentsTable } from './ChecklistAssignmentsTable'

export type FormWatch = UseFormReturn<any>['watch']

interface ChecklistAssignmentSectionProps {
  availableChecklists: ICustomerFormSchema[]
  selectedChecklists: ICustomerFormSchema[]
  onAddChecklist: (checklistId: number) => void
  onToggleMovement: (formSchemaId: number, movementType: number, checked: boolean) => void
  onRemoveChecklist: (checklistId: number) => void
  formWatch: FormWatch
}

export const ChecklistAssignmentSection: React.FC<ChecklistAssignmentSectionProps> = ({
  availableChecklists,
  selectedChecklists,
  onAddChecklist,
  onToggleMovement,
  onRemoveChecklist,
  formWatch,
}) => {
  const { t } = useTranslation('main-component-type')

  return (
    <>
      <SubTitle>{t('assign-checklists')}</SubTitle>
      <Stack>
        <FormSelectField
          data={availableChecklists}
          name="checklistSelect"
          label={t('select-checklist-templates')}
          getOptionLabel={option => (typeof option === 'object' ? option.name : '')}
          isOptionEqualToValue={(o, v) => o?.id === v?.id}
          onChange={(_, value) => {
            if (value && typeof value === 'object' && 'id' in value) {
              onAddChecklist(value.id as number)
            }
          }}
          value={null}
        />
        {selectedChecklists.length > 0 && (
          <Box paddingX={1}>
            <ChecklistAssignmentsTable
              selectedChecklists={selectedChecklists}
              onToggleMovement={onToggleMovement}
              onRemoveChecklist={onRemoveChecklist}
              formWatch={formWatch}
            />
          </Box>
        )}
      </Stack>
    </>
  )
}

const SubTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.2rem',
  paddingLeft: '8px',
  color: getThemeColor(theme, MUIThemeColors.primaryMain),
}))
